export const HOME = "/";
export const START_QUIZ = "/start-quiz";
export const FINAL_RESULT = "/final-result";